module.exports = __webpack_public_path__ + "img/vu.e3adbd19.svg";